import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Card } from 'src/app/core/models/card/card.model';
import { Controller } from 'src/app/core/models/controller.model';
import { LocationGroupType } from 'src/app/core/models/location-group-type.enum';
import { Permission } from 'src/app/core/models/permissions/permission.model';
import { User } from 'src/app/core/models/user/user.model';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { ApiRolesService } from 'src/app/modules/roles/services/http/api-roles.service';
import { RolesService } from 'src/app/modules/roles/services/roles.service';
import { ApiUsersService } from 'src/app/modules/users/services/http/api-users.service';
import { UsersService } from 'src/app/modules/users/services/users.service';

import { CardsService } from 'src/app/modules/users/services/cards.service';
import { CardFilter } from 'src/app/core/models/card-page-filter.model';
import { PaginationData } from 'src/app/core/models/pagination-data.model';
import { enterAnimation } from 'src/app/shared/animations/animations';
import { EditCardModalComponent } from 'src/app/modules/rooms/components/edit-card-modal/edit-card-modal.component';
import { LocationGroup, ApiLocationGroupsService } from 'src/app/shared/services/api-location-groups.service';
import { LocationGroupsService } from 'src/app/shared/services/location-groups.service';
import { CurrentUserStoreService } from 'src/app/core/services/current-user-store.service';
import { Location } from 'src/app/core/models/project/location.model';
import { CustomTranslatePipe } from 'src/app/shared/pipes/custom-translate.pipe';
import { ApiProjectService } from 'src/app/modules/project/services/http/api-project.service';
import { CardType } from 'src/app/core/models/card/card-type.model';
import { SoftwarePermissionCode } from 'src/app/core/models/permissions/permission-code';

@Component({
  selector: 'app-access-control-modal-cards',
  templateUrl: './access-control-modal-cards.component.html',
  animations: [enterAnimation],
  styleUrls: ['./access-control-modal-cards.component.scss'],
})
export class AccessControlModalCardsComponent implements OnInit, OnDestroy/* , AfterViewInit */  {
  // @ViewChild('selectContainerRooms') selectContainerRooms: SelectContainerComponent;
  @Input() location: Location;
  controllers: Controller[];

  mainController: Controller;
  popoverOpened = false;
  cards: Card[] = [];
  guestCards: Card[] = [];
  allStaffCards: Card[] = [];
  requestBody: CardFilter = new CardFilter();
  queryParams = { pageNumber: 1, pageSize: 50 };
  paginationData: PaginationData = new PaginationData();
  roomSwap = false;
  // openModal = false;

  permissions: Permission[];
  permissionsSubscription: Subscription;

  accessControlIds: string[] = [];
  floorList$: Observable<LocationGroup[]> = this.locationGroupsService.getFloorList();

  // newRoom: Controller[] = [];
  newArrayOfLocations: Location[] = [];

  movingGuest: User;

  // selectedObjectRooms;
  // selectedSubObjectRooms;

  guestAddedSubscription: Subscription;

  cardOnHolder: boolean;
  cardOnHolderSubscription: Subscription;
  openCardOnReaderModal = false;
  cardExist = false;
  userBeingCreated = false;
  // showStaffCards = false
  activePopup: string;
  userToShowInPopup: User;
  tablesReady = false;

  signedInUser: User;
  swPermissions = SoftwarePermissionCode;
  lastGuestCardOnHolderHighlighted$ = this.cardsService.getLastGuestCardOnHolderHighlighted()

  cardSyncActiveSubscription: Subscription;
  cardSyncActive = false;
  User= User;

  dataLoading = false;

  constructor(private modalController: ModalController,
              private apiUsersService: ApiUsersService,
              private usersService: UsersService,
              private apiLocationGroupsService: ApiLocationGroupsService,
              private projectService: ProjectService,
              private locationGroupsService: LocationGroupsService,
              private rolesService: RolesService,
              private apiRolesService: ApiRolesService,
              private cardsService: CardsService,
              private currentUserStoreService: CurrentUserStoreService,
              private alertController: AlertController,
              private apiProjectService: ApiProjectService,
              private pipe: CustomTranslatePipe,
              ) {}

  ngOnInit(): void {
    this.controllers = this.location.controllers.$values;
    this.getMainController();
    this.getStaffCardsByLocation();
    this.getGuestCardsByLocation(1, 'DSC|VTO');
    this.getPermissions();
    this.getIsCardSyncActive();
    this.guestAddedSubscription = this.usersService.newGuestAdded.subscribe( () => {
      this.getStaffCardsByLocation();
      this.getGuestCardsByLocation();
    });
    this.signedInUser = Object.assign(new User(), this.currentUserStoreService.getUser());
  }

  getIsCardSyncActive(){
    this.cardSyncActiveSubscription = this.projectService.cardSyncActive$.subscribe(value => {
      this.cardSyncActive = value;
    });
  }

  getPermissions() {
    this.permissions = this.rolesService.getPermissions();
    this.apiRolesService.getPermissions().subscribe();
    this.permissionsSubscription = this.rolesService.permissionsChanged.subscribe(() => {
      this.permissions = this.rolesService.getPermissions();
    });
  }

  getGuestCardsByLocation(pageNumber: number = 1, pageSort?: string) {
    if (pageSort)  {
      this.requestBody.sorting = pageSort;
      }
    this.queryParams.pageNumber = pageNumber;
    this.dataLoading = true;
    this.apiUsersService.getGuestCardsForLocation(this.requestBody, this.queryParams, +this.location.locationId).subscribe({
      next: resp => {
        this.paginationData = JSON.parse(resp.headers.get('X-Pagination') ?? 'null');
        this.guestCards = resp.body ?? [];
        this.dataLoading = false;
      },
      error: () => { this.dataLoading = false; }
    });
  }

  onSort(sortBy: string) {
    this.requestBody.sorting = this.requestBody.sorting === 'ASC|' + sortBy ? 'DSC|' + sortBy : 'ASC|' + sortBy;
    this.getGuestCardsByLocation();
  }

  searchFilterReady(searchFilter: string) {
    this.requestBody.filtering = searchFilter;
    this.getGuestCardsByLocation();
  }

  setDateTimeFromTo(selectedDateTime: Date[]) {
    this.requestBody.dateTimeFrom = selectedDateTime[0];
    this.requestBody.dateTimeTo = selectedDateTime[1];
    this.getGuestCardsByLocation();
  }

  getStaffCardsByLocation() {
     const cardTypes = this.cardsService.getCardTypes();
    this.apiUsersService.getCardsByLocationAndType(+this.location.locationId, 0).subscribe( (allCards: Card[]) => {
      // const guestCards = [];
      const staffCards: Card[] = [];

      allCards.forEach((card)=> {
        const cardType: CardType = cardTypes.find((ct: CardType)=> {
          return card.type === ct.typeId
        })
       /*  if (CardType.isGuestCard(cardType)) {
          guestCards.push(card)
        } else */ if (CardType.isStaffCard(cardType)) {
          staffCards.push(card)
        }
      })

      /* this.guestCards = guestCards.filter( card => !card.isBackup);
      this.guestCards.sort((a, b) => {
        const dateA = a.validFrom instanceof Date ? a.validFrom.getTime() : new Date(a.validFrom).getTime();
        const dateB = b.validFrom instanceof Date ? b.validFrom.getTime() : new Date(b.validFrom).getTime();
        return dateA - dateB;
      }); // SORTING BY VALID FROM */

      this.allStaffCards = staffCards;
      this.allStaffCards.sort((a, b) => {
        const dateA = a.validFrom instanceof Date ? a.validFrom.getTime() : new Date(a.validFrom).getTime();
        const dateB = b.validFrom instanceof Date ? b.validFrom.getTime() : new Date(b.validFrom).getTime();
        return dateA - dateB;
      }); // SORTING BY VALID FROM

      this.tablesReady = true;
    })
    /* this.apiUsersService.getCardsByLocation(this.location.locationId).subscribe( (value: Card[]) => {
      this.cards = value;
      this.guestCards = this.cards.filter( card => card.type === 1);
      this.staffCards = this.cards.filter( card => card.type !==1);
      // this.guestCards = this.guestCards.sort((a,b) => (+this.getCardPosition(a)) - (+this.getCardPosition(b)))
      this.tablesReady = true;
    }) */
  }

  getMainController() {
    this.mainController = Controller.getMainController(this.controllers)
  }

  async deleteCard(card: Card) {
    const alert = await this.alertController.create({
      header: this.pipe.transform('Confirm delete'),
      message: this.pipe.transform('Delete card?'),
      buttons: [ {
        text: this.pipe.transform('Cancel'),
        role: 'cancel',
      },
        {
          text: this.pipe.transform('Delete'),
          handler: () => {
              this.apiUsersService.deleteUserCard(card).subscribe({
                next:() => {
                  this.getGuestCardsByLocation();
                  this.getStaffCardsByLocation();
                },
                error: ()=> {}
            });
          }
        }
      ],
    });
    await alert.present();
  }

  syncGuest(uid: string) {
    this.apiUsersService.syncCard(uid).subscribe();
  }

  groupControllersByLocation(mainController: Controller, arrayOfLocations: Location[]) {
    return this.apiLocationGroupsService.getLocationGroupsByType(LocationGroupType.AccessGroup).pipe(
      map( value => {
        value.forEach( group => {
          if (group.locations.some( loc => loc.controllers.$values.some( cont => cont.designation == mainController.designation))) {
            group.locations.forEach( location => {
              if (Location.isAccessControl(location)) {
                arrayOfLocations.push(location);
              }
            })
          }
        })
      })
    )
  }

  onCardOnreaderModalDecision(decision) {
    this.openCardOnReaderModal = false;
  }

  onModalDecisionCardExist(decision) {
    this.cardExist = false;
  }

  showAccess(event: Event, card: Card) {
    if (event.type === 'mouseenter') {
      this.activePopup = card.uid;
      if (!this.userToShowInPopup) {
        forkJoin([
          this.apiUsersService.getUser(card.userId),
          this.apiProjectService.getKeyOptionsAccessControllListForLocationId(this.location.locationId)
          ]).subscribe(([user, keyOptions])=> {
            this.userToShowInPopup = user;
            this.userToShowInPopup.permissions = user.permissions.filter( (perm: Permission) => {

              return perm.locationId !== this.location.locationId;
            });
          });
      }
    } else if (event.type === 'mouseleave') {
      this.activePopup = undefined;
      this.userToShowInPopup = undefined;
    }
  }

  showAccessPopup(uid: string) {
    if (this.activePopup === uid) {
      return true;
    }
  }

  async editCard(userId: number) {
    const modal = await this.modalController.create({
      component: EditCardModalComponent,
      cssClass: 'cards-popover',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps:  {
        location: this.location,
        userId: userId
        }
    });
    return await modal.present();
  }

  ngOnDestroy() {
    if (this.permissionsSubscription) {
      this.permissionsSubscription.unsubscribe();
    }
    if (this.guestAddedSubscription) {
      this.guestAddedSubscription.unsubscribe();
    }
    if (this.cardOnHolderSubscription) {
      this.cardOnHolderSubscription.unsubscribe();
    }
    if (this.cardSyncActiveSubscription) {
      this.cardSyncActiveSubscription.unsubscribe();
    }
    this.cardsService.setLastGuestCardOnHolderHighlighted(undefined);
  }
}
